module.exports = __webpack_public_path__ + "img/girl-body-front.ab4a90db.png";